import { useEffect, useState } from "react";

export function useCartCount() {
  const [count, setCount] = useState(0);
  useEffect(() => {
    const refresh = () => {
      try {
        const items = JSON.parse(localStorage.getItem("cart") || "[]");
        setCount(items.reduce((s, x) => s + x.quantity, 0));
      } catch { setCount(0); }
    };
    refresh();
    window.addEventListener("cart:changed", refresh);
    return () => window.removeEventListener("cart:changed", refresh);
  }, []);
  return count;
}
